import { createFileRoute } from "@tanstack/react-router"
import CoreOrganizationManagerPage from "@/components/coreOrgManager/CoreOrganizationManagerPage"

export const Route = createFileRoute("/core/organization-manager")({
  component: CoreOrganizationManagerPage
})
